// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trimble-search .sui-layout-main {
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 1.5rem;
}

/* RESULTS - RESULTS LIST */

.trimble-search .result-list {
  padding: 0;
}

.trimble-search .result-list .no-results-page {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 2rem;
}

.trimble-search .result-list ul.no-results-suggestions-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  list-style: disc;
  padding-left: 1.5rem;
}

.trimble-search .result-list ul.no-results-suggestions-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.trimble-search .result-list .sui-result {
  display: flex;
  flex-direction: column;
  font-family: inherit !important;
  background: none !important;
  box-shadow: none !important;
  padding: 1.5rem 0 !important;
  margin: 0 !important;
  gap: 0.75rem;

  border-radius: 0rem;
  border-bottom: 1px solid #6a6e79;
  border-right: none;
  border-left: none;
}

.trimble-search .result-list .sui-result:first-of-type {
  border-top: 1px solid #6a6e79;
}

.trimble-search .result-list .sui-result .result-header {
  display: flex;
  flex-direction: column;
}

.trimble-search .result-list .sui-result .result-header h4 > a {
  color: #0063a3 !important;
  word-break: break-word;
}

.trimble-search .result-list .sui-result .result-header h4 > a:hover {
  color: #217cbb !important;
}

.trimble-search .result-list .sui-result .result-header h4 > a:focus {
  text-decoration: underline !important;
  outline: none;
}

.trimble-search .result-list .sui-result .result-header .url-crumbs {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 0.25rem;
  flex-wrap: wrap;
  padding-top: 0.5rem;
}

.trimble-search .result-list .sui-result .result-header .url-crumbs > span {
  color: #6a6e79 !important;
  font-size: 0.875rem !important;
  font-family: "Open Sans", sans-serif;
  font-size: 0.875rem !important;
  font-style: normal;
  font-weight: 400;
  line-height: 1.25rem;
  letter-spacing: 0.00438rem;
}

.trimble-search .result-list .sui-result .result-header .url-crumbs svg {
  width: 1.125rem;
  height: 1.125rem;
  aspect-ratio: 1/1;
}

.trimble-search .result-list .sui-result .result-body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  line-height: 1.5rem;
  list-style: none;
}

.trimble-search .result-list .sui-result .result-body p {
  margin: 0;
}

.trimble-search .result-list .sui-result .result-body .result-teaser {
  flex: 2 auto;
  display: flex;
  min-width: 50%;
}

.trimble-search .result-list .sui-result .result-body .result-preview {
  text-align: center;
  flex: 1 auto;
  margin-top: 1.5rem;
  margin-left: 2.5625rem;
}

.trimble-search .result-list .sui-result .result-body .result-preview > img {
  max-height: 10.688rem;
  border: 1px solid #176ba6;
}

.trimble-search .result-list .sui-result .result-footer {
  padding-top: 0.75rem;
}

.trimble-search .result-list .sui-result .tag-list {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 0.75rem;
  align-self: stretch;
  flex-wrap: wrap;
}

.trimble-search .result-list .sui-result .tag-list .result-tag {
  display: flex;
  height: 1.5rem;
  padding: 0 0.5rem;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;

  border-radius: 0.5rem;
  border: 1px solid #f1f1f6;
  background-color: #f1f1f6;
  color: var(--primary-black);

  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 600;
  line-height: 1rem;

  cursor: pointer;
}

.trimble-search .result-list .sui-result .tag-list .result-tag:hover {
  background-color: var(--button-hover-bg-color);
  color: #252a2e;
}

.trimble-search .result-list .sui-result .tag-list .result-tag:focus {
  background-color: var(--button-hover-bg-color);
}

@media (max-width: 800px) {
  .trimble-search .sui-layout-main {
    gap: 1.5rem;
    width: 100%;
  }

  .trimble-search .result-list .sui-result .result-body {
    flex-direction: column;
  }

  .trimble-search button.sui-layout-sidebar-toggle {
    display: flex;
    padding: 0.75rem;
    margin: 0;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;

    border-radius: 0.5rem;
    border: 1px solid var(--primary-black-opacity-60);
    color: var(--primary-black);

    font-family: "Open Sans", sans-serif;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.5rem;
    letter-spacing: 0.0015rem;
  }

  .trimble-search button.sui-layout-sidebar-toggle svg {
    color: var(--primary-black);
    width: 1.125rem;
    height: 1.125rem;
  }

  .trimble-search button.sui-layout-sidebar-toggle svg path {
    fill: var(--primary-black);
    stroke: none;
  }

  .trimble-search button.sui-layout-sidebar-toggle:hover {
    border: 1px solid var(--Blue-Blue-Light, #217cbb);
    background: var(--Blue-Blue-Pale, #dcedf9);
  }

  .trimble-search button.sui-layout-sidebar-toggle:focus {
    border: 1px solid var(--Primary-Palette-Trimble-Blue-Dark, #004f83);
    background: rgba(0, 99, 163, 0.18);
  }

  .trimble-search .button-wrapper .mobile-sidebar-header > button.sui-layout-sidebar-toggle.close-sidebar {
    padding: 0.25em;
  }

  .trimble-search .result-list .sui-result .result-body .result-preview > img {
    margin-left: 0;
    margin-top: 1.5rem;
  }
}

@media (max-width: 600px) {
  .trimble-search .result-list .sui-result .result-body {
    flex-direction: column;
  }

  .trimble-search .result-list .sui-result .result-body > div {
    width: 100%;
  }

  .trimble-search .result-list .sui-result .result-body .result-preview img {
    max-height: unset;
    width: 100%;
  }

  .trimble-search .result-list .sui-result .result-header .url-crumbs {
    padding-top: 0.5rem;
    width: 100%;
  }

  .trimble-search .result-list .sui-result .result-header .url-crumbs > span {
    line-height: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/results/results.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;;AAEA,2BAA2B;;AAE3B;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,YAAY;;EAEZ,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;;EAEZ,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;;EAE3B,kBAAkB;EAClB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;;EAEjB,eAAe;AACjB;;AAEA;EACE,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;;IAEX,qBAAqB;IACrB,iDAAiD;IACjD,2BAA2B;;IAE3B,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;EAEA;IACE,iDAAiD;IACjD,0CAA0C;EAC5C;;EAEA;IACE,mEAAmE;IACnE,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".trimble-search .sui-layout-main {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  gap: 1.5rem;\n}\n\n/* RESULTS - RESULTS LIST */\n\n.trimble-search .result-list {\n  padding: 0;\n}\n\n.trimble-search .result-list .no-results-page {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding-bottom: 2rem;\n}\n\n.trimble-search .result-list ul.no-results-suggestions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  list-style: disc;\n  padding-left: 1.5rem;\n}\n\n.trimble-search .result-list ul.no-results-suggestions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.trimble-search .result-list .sui-result {\n  display: flex;\n  flex-direction: column;\n  font-family: inherit !important;\n  background: none !important;\n  box-shadow: none !important;\n  padding: 1.5rem 0 !important;\n  margin: 0 !important;\n  gap: 0.75rem;\n\n  border-radius: 0rem;\n  border-bottom: 1px solid #6a6e79;\n  border-right: none;\n  border-left: none;\n}\n\n.trimble-search .result-list .sui-result:first-of-type {\n  border-top: 1px solid #6a6e79;\n}\n\n.trimble-search .result-list .sui-result .result-header {\n  display: flex;\n  flex-direction: column;\n}\n\n.trimble-search .result-list .sui-result .result-header h4 > a {\n  color: #0063a3 !important;\n  word-break: break-word;\n}\n\n.trimble-search .result-list .sui-result .result-header h4 > a:hover {\n  color: #217cbb !important;\n}\n\n.trimble-search .result-list .sui-result .result-header h4 > a:focus {\n  text-decoration: underline !important;\n  outline: none;\n}\n\n.trimble-search .result-list .sui-result .result-header .url-crumbs {\n  display: flex;\n  align-items: center;\n  align-self: stretch;\n  gap: 0.25rem;\n  flex-wrap: wrap;\n  padding-top: 0.5rem;\n}\n\n.trimble-search .result-list .sui-result .result-header .url-crumbs > span {\n  color: #6a6e79 !important;\n  font-size: 0.875rem !important;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.875rem !important;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.25rem;\n  letter-spacing: 0.00438rem;\n}\n\n.trimble-search .result-list .sui-result .result-header .url-crumbs svg {\n  width: 1.125rem;\n  height: 1.125rem;\n  aspect-ratio: 1/1;\n}\n\n.trimble-search .result-list .sui-result .result-body {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  line-height: 1.5rem;\n  list-style: none;\n}\n\n.trimble-search .result-list .sui-result .result-body p {\n  margin: 0;\n}\n\n.trimble-search .result-list .sui-result .result-body .result-teaser {\n  flex: 2 auto;\n  display: flex;\n  min-width: 50%;\n}\n\n.trimble-search .result-list .sui-result .result-body .result-preview {\n  text-align: center;\n  flex: 1 auto;\n  margin-top: 1.5rem;\n  margin-left: 2.5625rem;\n}\n\n.trimble-search .result-list .sui-result .result-body .result-preview > img {\n  max-height: 10.688rem;\n  border: 1px solid #176ba6;\n}\n\n.trimble-search .result-list .sui-result .result-footer {\n  padding-top: 0.75rem;\n}\n\n.trimble-search .result-list .sui-result .tag-list {\n  display: flex;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 0.75rem;\n  align-self: stretch;\n  flex-wrap: wrap;\n}\n\n.trimble-search .result-list .sui-result .tag-list .result-tag {\n  display: flex;\n  height: 1.5rem;\n  padding: 0 0.5rem;\n  justify-content: center;\n  align-items: center;\n  gap: 0.25rem;\n\n  border-radius: 0.5rem;\n  border: 1px solid #f1f1f6;\n  background-color: #f1f1f6;\n  color: var(--primary-black);\n\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 0.75rem;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 1rem;\n\n  cursor: pointer;\n}\n\n.trimble-search .result-list .sui-result .tag-list .result-tag:hover {\n  background-color: var(--button-hover-bg-color);\n  color: #252a2e;\n}\n\n.trimble-search .result-list .sui-result .tag-list .result-tag:focus {\n  background-color: var(--button-hover-bg-color);\n}\n\n@media (max-width: 800px) {\n  .trimble-search .sui-layout-main {\n    gap: 1.5rem;\n    width: 100%;\n  }\n\n  .trimble-search .result-list .sui-result .result-body {\n    flex-direction: column;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle {\n    display: flex;\n    padding: 0.75rem;\n    margin: 0;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n\n    border-radius: 0.5rem;\n    border: 1px solid var(--primary-black-opacity-60);\n    color: var(--primary-black);\n\n    font-family: \"Open Sans\", sans-serif;\n    font-size: 1.125rem;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 1.5rem;\n    letter-spacing: 0.0015rem;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle svg {\n    color: var(--primary-black);\n    width: 1.125rem;\n    height: 1.125rem;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle svg path {\n    fill: var(--primary-black);\n    stroke: none;\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle:hover {\n    border: 1px solid var(--Blue-Blue-Light, #217cbb);\n    background: var(--Blue-Blue-Pale, #dcedf9);\n  }\n\n  .trimble-search button.sui-layout-sidebar-toggle:focus {\n    border: 1px solid var(--Primary-Palette-Trimble-Blue-Dark, #004f83);\n    background: rgba(0, 99, 163, 0.18);\n  }\n\n  .trimble-search .button-wrapper .mobile-sidebar-header > button.sui-layout-sidebar-toggle.close-sidebar {\n    padding: 0.25em;\n  }\n\n  .trimble-search .result-list .sui-result .result-body .result-preview > img {\n    margin-left: 0;\n    margin-top: 1.5rem;\n  }\n}\n\n@media (max-width: 600px) {\n  .trimble-search .result-list .sui-result .result-body {\n    flex-direction: column;\n  }\n\n  .trimble-search .result-list .sui-result .result-body > div {\n    width: 100%;\n  }\n\n  .trimble-search .result-list .sui-result .result-body .result-preview img {\n    max-height: unset;\n    width: 100%;\n  }\n\n  .trimble-search .result-list .sui-result .result-header .url-crumbs {\n    padding-top: 0.5rem;\n    width: 100%;\n  }\n\n  .trimble-search .result-list .sui-result .result-header .url-crumbs > span {\n    line-height: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
